import { motion } from "framer-motion";
import { CalendarDays, X } from "lucide-react";

const closures = [
  "2 Novembre 2026",
  "7 e 8 Dicembre 2026",
  "Dal 23 Dicembre 2026 al 6 Gennaio 2027 compresi",
  "Dal 25 Marzo 2027 al 30 Marzo 2027 compresi",
  "Dal 31 Maggio 2027 al 2 Giugno 2027 compresi",
];

export const Calendario = () => (
  <section id="calendario" data-testid="calendario-section" className="py-20 sm:py-28 scroll-mt-24 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <p className="text-sm font-800 uppercase tracking-[0.2em] text-amber-500">Calendario Scolastico</p>
        <h2 className="mt-2 font-heading text-3xl sm:text-4xl md:text-5xl font-700 text-slate-800">Anno Scolastico 2026 – 2027</h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mt-10 rounded-[2rem] bg-gradient-to-br from-amber-50 to-rose-50 border border-amber-100 p-8 sm:p-10"
      >
        <div className="flex items-center gap-3">
          <span className="grid place-items-center h-12 w-12 rounded-2xl bg-white text-amber-500 shadow-sm">
            <CalendarDays className="h-6 w-6" />
          </span>
          <h3 className="font-heading text-xl font-700 text-slate-800">Apertura e chiusura</h3>
        </div>
        <p className="mt-4 text-slate-700 font-700 text-lg">
          Il nido aprirà il <span className="text-emerald-600">1° Settembre 2026</span> e chiuderà il{" "}
          <span className="text-rose-500">30 Luglio 2027</span>.
        </p>

        <h3 className="mt-8 font-heading text-xl font-700 text-slate-800">Il nido resterà chiuso:</h3>
        <ul className="mt-4 space-y-3">
          {closures.map((c) => (
            <li key={c} data-testid={`chiusura-${c}`} className="flex items-start gap-3 rounded-2xl bg-white p-4 shadow-sm">
              <span className="grid place-items-center h-7 w-7 shrink-0 rounded-full bg-rose-100 text-rose-500 mt-0.5">
                <X className="h-4 w-4" />
              </span>
              <span className="font-700 text-slate-700">{c}</span>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);
